<article
  class="activity-component relative flex flex-col lg:grid lg:grid-cols-11"
>
  <header
    class="flex flex-col order-first lg:col-span-5 activity-component__header"
  >
    <img
      class="w-full mb-4 lg:mb-0 lg:mt-4 lg:order-3"
      [src]="picture"
      alt=""
    />

    <div class="lg:order-1">
      <app-activity-heading
        [activity]="activity"
        [averageRating]="averageRating"
        [reviewCount]="reviewCount"
      ></app-activity-heading>
    </div>
    <a
      *ngIf="organization"
      (click)="anchorHandler($event)"
      href="#"
      class="lg:order-2 text-vtmn-play-content-brand text-sm"
      >{{ organization.name }}</a
    >
  </header>

  <section class="mt-4 md:mt-5 lg:col-span-5 lg:row-start-2">
    <span class="title-5 mb-2">
      {{ 'activity.description.title' | translate }}
    </span>

    <h2
      class="activity-component__description"
      ngPreserveWhitespaces
      aria-label="activity description"
      [innerText]="activity?.description"
    >
      {{ activity?.description }}
    </h2>
  </section>

  <div
    class="mt-4 order-first lg:col-span-5 lg:col-start-7 lg:mt-0 lg:row-start-1 lg:row-end-7"
    *ngIf="!isPreview && timeslots?.length"
  >
    <ng-content></ng-content>
  </div>

  <section
    *ngIf="activity?.providedEquipment?.length > 0"
    class="mt-4 md:mt-5 lg:col-span-5 lg:row-start-3"
  >
    <h3 class="title-5 mb-3">
      {{ 'activity.equipment.provided' | translate }}
    </h3>

    <ul>
      <li
        class="flex mb-2 break-words"
        *ngFor="let equipment of activity?.providedEquipment"
      >
        <vtmn-play-icon
          class="text-green-dark-1 mt-1 mr-3"
          [name]="iconTypeEnum.Check"
        ></vtmn-play-icon>
        {{ equipment }}
      </li>
    </ul>
  </section>

  <section
    *ngIf="
      activity?.requiredEquipment && activity?.requiredEquipment?.length > 0
    "
    class="mt-4 md:mt-5 lg:col-span-5 lg:row-start-4"
  >
    <h3 class="title-5 mb-3">
      {{ 'activity.equipment.required' | translate }}
    </h3>

    <ul>
      <li
        class="flex mb-2 break-words"
        *ngFor="let equipment of activity?.requiredEquipment"
      >
        <vtmn-play-icon
          class="text-green-dark-1 mt-1 mr-3"
          [name]="iconTypeEnum.Check"
        ></vtmn-play-icon>
        {{ equipment }}
      </li>
    </ul>
  </section>

  <section
    *ngIf="!activity?.isLive"
    class="mt-4 md:mt-5 lg:col-span-5 lg:row-start-5"
  >
    <h2 class="title-5 mb-2">
      {{ 'activity.location.title' | translate }}
    </h2>

    <p>
      {{ activity?.location.address?.streetAddress }}
    </p>

    <p *ngIf="activity?.location?.address?.addressRegion">
      {{ activity?.location.address.addressRegion }}
    </p>

    <p>
      {{ activity?.location?.address?.postalCode }}
      {{ activity?.location?.address?.addressLocality }}
    </p>
    <div
      appObserveElement
      #intersection="intersection"
      (isIntersecting)="isIntersecting($event)"
    >
      <app-map
        *ngIf="isBrowser"
        class="block h-google-maps mt-3 -mx-3 overflow-hidden xs:mx-0"
      ></app-map>
    </div>
    <app-tips
      *ngIf="activity?.location?.precision"
      class="block mt-4"
      [icon]="iconTypeEnum.WarningError"
      [variant]="tipsVariant.INFO"
      [title]="'activity.location.precision.title' | translate"
      [tips]="activity?.location.precision"
    >
    </app-tips>
  </section>
  <section
    id="organization-section"
    class="mt-4 pt-5 md:mt-5 lg:col-span-5 lg:row-start-6"
    *ngIf="organization"
  >
    <h2 class="title-5 mb-2">
      {{ 'attendee.activity_detail.organizer.title' | translate }}
    </h2>

    <div class="flex items-center">
      <img
        *ngIf="organization.logo; else noLogo"
        class="rounded-full object-cover w-organizer-logo h-organizer-logo"
        [src]="organization.logo"
        alt=""
        loading="lazy"
      />

      <ng-template #noLogo>
        <vtmn-play-icon
          class="rounded-full flex items-center text-center justify-center text-4xl w-organizer-logo h-organizer-logo text-white bg-blue-gradient"
          [name]="accountIcon"
        ></vtmn-play-icon>
      </ng-template>

      <div class="ml-3">
        <h3 class="title-4 break-words" [attr.aria-label]="organization?.name">
          {{ organization?.name }}
        </h3>
        <a class="activity-component__see-profile" [href]="organizerPageUrl">
          {{ 'attendee.activity_detail.organizer.see_profile' | translate }}
        </a>
      </div>
    </div>

    <section class="activity-component__organizer-review organizer-review">
      <span class="organizer-review__title">
        {{ 'attendee.activity_detail.organizer.review.title' | translate }}
      </span>
      <app-vtmn-rating
        *ngIf="organizationReviewsStats"
        [value]="organizationReviewsStats.averageRating"
        [size]="organizerReviewsSize"
        [emphasis]="true"
        [showValue]="true"
        [comments]="organizerReviewsTranslation"
      ></app-vtmn-rating>

      <p class="organizer-review__text">
        {{ 'attendee.activity_detail.organizer.review.text' | translate }}
      </p>

      <a
        *ngIf="organizationReviewsStats.count"
        class="organizer-review__link"
        [routerLink]="
          [
            '/attendee.organizer/',
            organization.identifier,
            organizationNameFormatted,
            'attendee.reviews',
          ] | localize
        "
      >
        {{ 'attendee.activity_detail.organizer.review.link' | translate }}
      </a>
    </section>

    <section>
      <h3 class="activity-component__organizer-description">
        <ng-container *ngIf="!isShortDescription">
          <span
            *ngIf="!isOpen"
            [innerText]="
              organization.description.substring(0, 150).trim() + '...'
            "
          >
            {{ organization.description.substring(0, 150).trim() }}...
          </span>
          <span *ngIf="isOpen" [innerText]="organization?.description">
            {{ organization?.description }}
          </span>
        </ng-container>
        <ng-container *ngIf="isShortDescription">
          <span [innerText]="organization?.description">
            {{ organization?.description }}
          </span>
        </ng-container>
      </h3>
      <button
        *ngIf="!isShortDescription"
        class="activity-component__organizer-description__button"
        (click)="seeMore()"
      >
        {{ seeButtonTranslation }}
      </button>
    </section>

    <a
      *ngIf="!isPreview && !isBms"
      app-vtmn-play-button
      class="activity-component__contact-organizer"
      [class.w-full]="isMobileDevice"
      [variant]="vtmnPlayButtonVariant.PRIMARY"
      [shape]="
        isMobileDevice
          ? vtmnPlayButtonShape.SQUARED
          : vtmnPlayButtonShape.ROUNDED
      "
      (click)="storeMessagingData()"
    >
      {{ 'attendee.activity_detail.organizer.contact' | translate }}
    </a>
  </section>
  <div
    appObserveElement
    #intersection="intersection"
    (isIntersecting)="isReviewsIntersecting($event)"
    class="lg:col-span-5 lg:row-start-7"
  >
    <ng-container *ngIf="!isPreview && hasScrolled">
      <app-activity-reviews
        [averageAttributeRating]="averageAttributeRating"
        [averageRating]="averageRating"
        [recommendationRate]="recommendationRate"
        [hasReview]="hasReview"
        [reviewCount]="reviewCount"
        [reviews]="reviews"
      ></app-activity-reviews>
    </ng-container>
  </div>
</article>
